export default __webpack_public_path__ + "images/react/images/growth-logo-white.png";